// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"293":"39e15a4a","479":"b4848691","835":"a3adfcc5"}[chunkId] + ".chunk.css";
};